var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavbarColumnOff = function SvgNavbarColumnOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    d: "M3.75 1.5v18a3 3 0 0 0 3 3h13.5v-21zm12 1.5v5.205l-1.5-1.223-1.5 1.223V3zm3 18h-12c-.825 0-1.5-.675-1.5-1.5V3h6v6c0 .457.27.863.697 1.043.406.172.87.082 1.193-.21l1.117-.908 1.118.907c.21.195.48.3.758.3.142 0 .292-.03.434-.082.42-.173.698-.585.698-1.043V3h1.5v18z"
  })));
};
export default SvgNavbarColumnOff;